export default __webpack_public_path__ + "static/media/delete.ab5d12a8.svg";